import { Button, Theme, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import React from "react";
import { TranslationKey } from "../../../translations/TranslationKey";
import TranslatedMessage from "../../translations/TranslatedMessage";
import { useSignUpContext } from "../CertificationDataWizardContext/CertificationDataWizardContext";
import { useHistory } from "react-router";
import { routesPaths } from "../../../Routes";

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    width: "95%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: theme.spacing(3),
    gap: theme.spacing(2) + "px",
  },
  button: {
    marginRight: theme.spacing(1),
  },
  instructions: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
    textAlign: "center",
  },
}));

const EmailConfirmationSent: React.FunctionComponent = () => {
  const {
    data: { creationErrors },
  } = useSignUpContext();
  const classes = useStyles();
  const history = useHistory();

  const id: TranslationKey =
    creationErrors && creationErrors.length > 0 ? "candidateWizard.error" : "candidateWizard.success";

  return (
    <div className={classes.root}>
      <Typography variant="h4" className={classes.instructions}>
        <TranslatedMessage id={id} />
      </Typography>
      <div>
        <Button variant="contained" color="primary" onClick={() => history.push(routesPaths.candidateHome())}>
          <TranslatedMessage id="home.candidate" />
        </Button>
      </div>
    </div>
  );
};

export default EmailConfirmationSent;
